import styled, { css } from 'styled-components';
import THEMES from '~/themes/themes';

interface ContainerProps {
  isFocused: boolean;
  disabled?: boolean;
  colorLine?: string;
  colorLabel?: string;
  collapsible?: boolean;
  heightWhenOpen?: string;
}

export const ContainerOptions = styled.div<ContainerProps>`
  width: 100%;
  height: ${({ collapsible, isFocused, heightWhenOpen }) =>
    !collapsible
      ? '170px'
      : isFocused
        ? (heightWhenOpen ?? '170px')
        : '0px'};
  overflow: hidden;

  > div {
    height: 100%;
    overflow-y: scroll;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #ddd;
      margin-top: 0;
    }
    &::-webkit-scrollbar-thumb {
      background: ${THEMES.colors.primary};
      border: 3px solid ${THEMES.colors.primary};
    }
  }

  .option {
    padding: 10px 10px;

    :hover {
      background: #f1f1f1;
    }
  }
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  width: -webkit-fill-available;
  /* margin-bottom: 22px; */
  color: #4a4b4a;
  font-size: 1rem !important;
  pointer-events: ${({ disabled }) => disabled && 'none'};

  label {
    font-size: 12px;
    color: black;
  }
`;

export const IconRight = styled.img`
  align-self: center;
  cursor: pointer;
  padding-bottom: 14px;
  padding-right: 3%;
`;

export const ErrorMessage = styled.span`
  position: absolute;
  bottom: -15px;
  color: ${({ theme }) => theme.colors.error};
  font-size: 12px;
`;

export const Value = styled.div`
  flex: 1;
  cursor: pointer;
`;

export const CheckBox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: #a1a1a1;
  width: 1.05em;
  height: 1.05em;
  border: 0.15em solid #a1a1a1;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;

  &:before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #e71037;
    transform-origin: center center;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }
  &:checked:before {
    transform: scale(1);
  }
`;
